import styled from 'styled-components';

export const MainTaxes = styled.div`
    display: flex;
    flex-direction: column !important;
`;